<template>
  <div class="wrap">
    <header v-if="$route.query.from !='bs'">
      <img src="../assets/banner3.png" alt="">
    </header>
    <div class="headline">
      <p>身份证上传</p>
      <span>ID card upload</span>
    </div>
    <div class="tailoring" v-if="model">
      <div class="test">
        <vueCropper ref="cropper2" :img="example.img" :outputSize="example.size" :outputType="example.outputType"
                    :info="example.info" :canScale="example.canScale" :autoCrop="example.autoCrop"
                    :autoCropWidth="example.autoCropWidth" :autoCropHeight="example.autoCropHeight"
                    :fixed="example.fixed"
                    :fixedNumber="example.fixedNumber" :enlarge="4"></vueCropper>
        <div class="croppers">
          <button @click="tail">上传</button>
          <button @click="cancel">取消</button>
        </div>
      </div>
    </div>
    <form class="card" >
      <div class="upload">
        <dl>
          <dt>
            <img v-if="charactersImg!==''" :src="charactersImg" @click="characters">
            <img v-else src="../assets/正面.png" alt="" @click="characters">
            <input id="charactersImg" type="file" ref="characters" accept="image/*" @change="getCharacters"
                   style="display: none;">
          </dt>
          <dd>点击上传人物面</dd>
        </dl>
        <dl>
          <dt>
            <img v-if="emblemImg!==''" :src="emblemImg" @click="emblem">
            <img v-else src="../assets/反面.png" alt="" @click="emblem">
            <input id="emblemImg" type="file" ref="emblem" accept="image/*" @change="getEmblem" style="display: none;">
          </dt>
          <dd>点击上传国徽面</dd>
        </dl>
      </div>
      <div class="fills">
        <div class="num">
          <div>
            <label for="">姓名：</label>
            <input type="text" placeholder="上传照片后自动识别姓名" v-model="formData.name">
          </div>
          <div>
            <label for="">身份证号：</label>
            <input type="text" placeholder="上传照片后自动识别" v-model="formData.idcard">
          </div>
          <div>
            <label for="">有效期限：</label>
            <input type="text" placeholder="格式为20220101或者2022-01-01" v-model="formData.term">
          </div>
          <div>
            <label for="">收件电话：</label>
            <input type="text" v-model="formData.tel">
          </div>
          <div>
            <label for="">快递单号：</label>
            <input type="text" v-model="formData.num">
          </div>
          <p>(手机号与订单号可以任选一个填写)</p>
        </div>
        <div class="reminder">
          <p>温馨提示：</p>
          <div>
            <p>身份证只用来做清关使用</p>
            <p>需要提供身份证照片正反面</p>
            <p>您可以在这里直接填写上传</p>
            <p>也可以添加微信公众号后直接发送图片</p>
            <p><span>微信公众号1：</span>{{ commonData?commonData.fastgoCode[0].content:'' }}</p>
            <!--<p><span>微信公众号2：</span>fastgocn</p>-->
            <p>您也可以自己先打上水印</p>
            <p>但请不要遮住文字和照片信息</p>
          </div>
        </div>
      </div>
      <div class="bind">
        <div   style="cursor: pointer" @click="submit">上传</div>
      </div>
      <p><i></i>根据海关总署规定，入境到大陆的包裹需向海关提供收件人身份证证件等相关信息，谢谢配合！</p>
    </form>
    <tips :flag="tipsFlag"></tips>
    <div class="continue-back" @click="continueFlag = false" v-if="continueFlag">
      <div class="continue-dialog">
        <div class="continue-dialog-title">该订单姓名与上传证件的姓名不符，是否继续</div>
        <div class="continue-dialog-button">
          <div class="continue-yes" @click.stop="handleContinue">是</div>
          <div class="continue-no" @click.stop="continueFlag = false">重新上传</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import {VueCropper} from 'vue-cropper'
  import request from '../utils/require'
  import tips from '../components/tips'
  import {check_upload_idcard_name} from '../services/selectSide'
  import {
    getAccessToken,
    aiBaidu,
    getAccessTokenSecond,
    sendError,
    getCOSparam,
    idCardSave,
    baidushibie
  } from '../services/upload'
  import axios from 'axios'

  export default {
    name: 'IdCardUpload',
    props: {},
    components: {
      VueCropper,
      tips
    },
    data() {
      return {
        // COS: '',
        // cos: '',
        // config_cos: {
        //   Bucket: 'fastgohk-1302586322',
        //   Region: 'ap-singapore',
        //   BucketType: 'hk',
        //   domin: 'fastgo.com.au'
        // },
        model: false,
        oriFrontFile: '',
        oriBackFile: '',
        charactersImg: '', // 存放预览的图片
        emblemImg: '', // 存放预览的图片
        charactersFile: '',
        emblemFile: '',
        charactersBaidu: '',
        emblemBaidu: '',
        front: false,
        verso: false,
        formData: {
          name: '',
          idcard: '',
          term: '',
          tel: '',
          num: '',
          gender: '',
          address: '',
          birth: '',
          nation: '',
          sign_place: ''
        },
        // validityperiod
        example: {
          img: '',
          info: true,
          size: 0.5,
          outputType: 'jpeg',
          canScale: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 550,
          autoCropHeight: 405,
          fixed: false,
          // 真实的输出宽高
          infoTrue: true,
          fixedNumber: [4, 3]
        },
        continueFlag: false,
        front_code: '',
        back_code: ''

      }
    },
    computed: {
      ...mapState({
        information: state => state.information,
        commonData: state => state.commonData,
        tipsFlag: state => state.tipsFlag,
      })
    },
    created() {
      // this.COS = require('cos-js-sdk-v5');
    },
    methods: {

      compress(img, width, height, ratio) {
        var canvas, ctx, img64;
        canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext("2d");
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < imageData.data.length; i += 4) {
          // 当该像素是透明的，则设置成白色
          if (imageData.data[i + 3] == 0) {
            imageData.data[i] = 255;
            imageData.data[i + 1] = 255;
            imageData.data[i + 2] = 255;
            imageData.data[i + 3] = 255;
          }
        }
        ctx.putImageData(imageData, 0, 0);
        ctx.drawImage(img, 0, 0, width, height);
        img64 = canvas.toDataURL(img.imgType, ratio);
        return img64;
      },
      base64ToBlob(base64Data) {
        let arr = base64Data.split(','),
          fileType = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          l = bstr.length,
          u8Arr = new Uint8Array(l);

        while (l--) {
          u8Arr[l] = bstr.charCodeAt(l);
        }
        return new Blob([u8Arr], {
          type: fileType
        });
      },
      blobToFile(newBlob, fileName) {
        newBlob.lastModifiedDate = new Date();
        newBlob.name = fileName;
        return newBlob;
      },
      getImgSize(base64url) {
        //获取base64图片大小，返回KB数字
        var str = base64url.replace('data:image/jpeg;base64,', '');//这里根据自己上传图片的格式进行相应修改

        var strLength = str.length;
        // 由字节转换为KB
        var size = "";
        size = (strLength / 1024).toFixed(2);
        return parseInt(size);
      },
      handleCompress(image, radio) {
        var base64 = ''
        base64 = this.compress(image, image.width / radio, image.height / radio, 1)
        if (this.getImgSize(base64) > 100 || radio <= 1) {
          console.log('识别完了')
          return base64
        } else {
          return this.handleCompress(image, radio - 1)
        }
      },
      //上传人物面
      characters() {
        document.getElementById('charactersImg').value = ''
        this.$refs.characters.click();
      },
      getCharacters(e) {
        this.front = true;
        // this.verso = false;
        let $target = e.target || e.srcElement;
        let file = $target.files[0];
        this.oriFrontFile = file
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = data => {
          var image = new Image();
          //文件类型
          image.imgType = 'image/jpeg';
          image.src = data.target.result;
          image.onload = () => {
            var base64url = ''
            if (this.getImgSize(data.target.result) > 100) {
              base64url = this.handleCompress(image, 5)
            } else {
              base64url = image.src
            }
            this.$store.commit('setTipsFlag', {tips: '正在识别', search_flag: true, tipsCode: 3, handle: true});
            this.uploadBaidu(base64url, 'front')
            var blob = this.base64ToBlob(base64url)
            this.charactersFile = this.blobToFile(blob, file.name)
          }
        }
      },
      //上传国徽面
      emblem() {
        document.getElementById('emblemImg').value = ''
        this.$refs.emblem.click();
      },
      getEmblem(e) {
        this.front = false;
        // this.verso = true;
        let $target = e.target || e.srcElement;
        let file = $target.files[0];
        this.oriBackFile = file
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = data => {
          var image = new Image();
          //文件类型
          image.imgType = 'image/jpeg';
          image.src = data.target.result;
          image.onload = () => {
            var base64url = ''
            if (this.getImgSize(data.target.result) > 100) {
              base64url = this.handleCompress(image, 5)
            } else {
              base64url = image.src
            }
            this.$store.commit('setTipsFlag', {tips: '正在识别', search_flag: true, tipsCode: 3, handle: true});
            this.uploadBaidu(base64url, 'back')
            var blob = this.base64ToBlob(base64url)
            this.emblemFile = this.blobToFile(blob, file.name)
          }
        }
      },
      uploadBaidu(baseData, side) {
        var content = {
          pic: baseData,
          side: side,
        }
        aiBaidu(content).then(res => {
          this.$store.commit('setTipsFlag', {search_flag: false, tipsCode: 1});
          if (res.code == 1) {
            if (res.data.image_status == 'normal') {
              if (side == 'front') {
                this.front_code = res.data.upcode
                this.charactersImg = baseData;
                this.charactersBaidu = res.data.words_result;
                this.baiduBack(side)
              } else {
                this.back_code = res.data.upcode
                this.emblemImg = baseData;
                this.emblemBaidu = res.data.words_result;
                this.baiduBack(side)
              }

            } else {
              if (side == 'front') {
                this.charactersImg = ''
              } else {
                this.emblemImg = ''
              }

              this.$store.commit('setTipsFlag', {tips: '请重新上传身份证', search_flag: true, tipsCode: 2});
            }
          } else {
            if (side == 'front') {
              this.charactersImg = ''
            } else {
              this.emblemImg = ''
            }
            this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 2});
          }

        })
      },
      baiduBack(side) {
        if (side == 'front') {
          this.formData.name = this.charactersBaidu['姓名'] ? this.charactersBaidu['姓名'].words : ''
          this.formData.idcard = this.charactersBaidu['公民身份号码'] ? this.charactersBaidu['公民身份号码'].words : ''
          this.formData.birth = this.charactersBaidu['出生'] ? this.charactersBaidu['出生'].words : ''
          this.formData.gender = this.charactersBaidu['性别'] ? this.charactersBaidu['性别'].words : ''
          this.formData.nation = this.charactersBaidu['民族'] ? this.charactersBaidu['民族'].words : ''
          this.formData.address = this.charactersBaidu['住址'] ? this.charactersBaidu['住址'].words : ''
        } else {

          this.formData.term = this.emblemBaidu['失效日期'] ? this.emblemBaidu['失效日期'].words : ''
          this.formData.sign_place = this.emblemBaidu['签发机关'] ? this.emblemBaidu['签发机关'].words : ''
        }
        console.log(this.formData)
      },
      idCard(saveinfo) {
        var that = this
        return new Promise(((resolve, reject) => {
          idCardSave(saveinfo).then(res => {
            if (res.code == 1) {
              var ossArr = res.data
              for (var i in ossArr) {
                if (ossArr[i].indexOf('_A') != -1) {
                  that.formData.path_a = ossArr[i]
                }
                if (ossArr[i].indexOf('_B') != -1) {
                  that.formData.path_b = ossArr[i]
                }
              }
              resolve()
            } else {
              that.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 2});
              reject()
            }
          })
        }))
      },
      submit() {
        if (this.charactersImg == '' || this.emblemImg == '') {
          this.$store.commit('setTipsFlag', {tips: '请将图片上传完整', search_flag: true, tipsCode: 2});
          return
        }
        if (!this.formData.name) {
          this.$store.commit('setTipsFlag', {tips: '请填写姓名', search_flag: true, tipsCode: 2});
          return
        }
        if (!this.formData.idcard) {
          this.$store.commit('setTipsFlag', {tips: '请填写身份证号', search_flag: true, tipsCode: 2});
          return
        }

        if (this.formData.tel) {
          if (!/^1([38][0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|9[0-9])\d{8}$/.test(this.formData.tel)) {
            this.$store.commit('setTipsFlag', {tips: '请填写正确电话号码', search_flag: true, tipsCode: 2});
            return
          }
        }
        if (this.formData.term){
          var reg1 = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;//格式2014-01-01
          var reg2 = /^[1-9]\d{3}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;//格式20140101
          var test = reg1.test(this.formData.term) || reg2.test(this.formData.term);
          if (!test && this.formData.term != '长期') {
            this.$store.commit('setTipsFlag', {tips: '请填写正确的日期格式', search_flag: true, tipsCode: 2});
            return
          }
        }
        if (!this.formData.tel && !this.formData.num) {
          this.$store.commit('setTipsFlag', {tips: '手机号和订单号必须填一个', search_flag: true, tipsCode: 2});
          return
        }

        if (this.formData.num) {
          var content = {
            receiver_name: this.formData.name,
            bill_no: this.formData.num,
          }
          check_upload_idcard_name({content: JSON.stringify(content)}).then((res) => {
            if (res.code == 1) {
              this.uploadAll()
            } else {
              this.continueFlag = true
            }
          }).catch(res => {
            this.$store.commit('setTipsFlag', {tips: res, search_flag: true, tipsCode: 2});
          })
        } else {
          this.uploadAll()

        }
      },
      async uploadAll() {
        this.$store.commit('setTipsFlag', {tips: '正在上传', search_flag: true, tipsCode: 3, handle: true});
        var saveinfo = {}
        if (this.charactersImg) {
          var commitName = this.fileName('front')
          saveinfo[this.front_code] = commitName
        }
        if (this.emblemImg) {
          var commitName = this.fileName('back')
          saveinfo[this.back_code] = commitName
        }
        await this.idCard({saveinfo: JSON.stringify(saveinfo)})
        this.uploadIdcard()

      },
      uploadIdcard(checkcode) {
        this.formData.datafrom = 6
        this.formData.gender = this.formData.gender === '女' ? 2 : 1
        request({
          url: '/User_upload/saveIdCard',
          method: 'POST',
          data: {
            content: JSON.stringify(this.formData)
          }
        }).then(res => {
          if (res.code == 1) {
            this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 1});
            setTimeout(() => {
              this.$router.push({path: '/'});
            }, 2000);
          } else {
            this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 2});
          }
        }).catch(() => {
          this.$store.commit('setTipsFlag', {tips: '网络错误', search_flag: true, tipsCode: 2});
        })

      },
      fileName(side) {
        if (this.charactersBaidu) {
          if (this.charactersBaidu['姓名'].words && this.charactersBaidu['公民身份号码'].words) {
            if (side == 'front') {
              return this.charactersBaidu['姓名'].words + this.charactersBaidu['公民身份号码'].words + '_A' + this.get_suffix(this.oriFrontFile.name)
            } else {
              return this.charactersBaidu['姓名'].words + this.charactersBaidu['公民身份号码'].words + '_B' + this.get_suffix(this.oriBackFile.name)
            }
          } else {
            if (side == 'front') {
              return this.formData.name + this.formData.idcard + '_A' + this.get_suffix(this.oriFrontFile.name)
            } else {
              return this.formData.name + this.formData.idcard + '_B' + this.get_suffix(this.oriBackFile.name)
            }
          }
        } else {
          if (side == 'front') {
            return this.formData.name + this.formData.idcard + '_A' + this.get_suffix(this.oriFrontFile.name)
          } else {
            return this.formData.name + this.formData.idcard + '_B' + this.get_suffix(this.oriBackFile.name)
          }
        }
      },
      get_suffix(filename) {
        var pos = filename.lastIndexOf('.')
        var suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      cancel() {
        this.model = false;
        if (this.front) {
          this.$refs.characters.value = null;
        } else {
          this.$refs.emblem.value = null;
        }
      },
      handleContinue() {
        this.continueFlag = false
        // this.uploadIdcard()
        this.uploadAll()
      }
    },
    mounted() {
      this.formData = {};
    }
  }
</script>
<style scoped lang="scss">
  .wrap {
    margin-bottom: 58px;
  }

  .test {
    width: 550px;
    height: 450px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -275px;
    margin-top: -225px;
    z-index: 9999;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .croppers {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        width: 100px;
        height: 30px;
        background: $bg-color;
        color: #fff;
        border: none;
        margin: 0 20px;
      }
      button:nth-child(2) {
        background: #4c4c4c;
      }
    }
  }

  .card {
    border-radius: 20px;
    width: 1000px;
    margin: 0 auto;
    .upload {
      height: 258px;
      background: #eeeeee;
      display: flex;
      justify-content: space-around;
      align-items: center;
      dl {
        img {
          width: 237px;
          height: 180px;
          cursor: pointer;
        }
        dd {
          text-align: center;
          line-height: 50px;
          font-size: 17px;
        }
      }
    }
    .fills {
      min-height: 294px;
      background: #4c4c4c;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 68px;
      .num {
        display: flex;
        flex-direction: column;
        div {
          display: flex;
          align-items: center;
          margin: 10px 0;
          label {
            display: inline-block;
            width: 90px;
            color: #fff;
            font-size: 18px;
            text-align: right;
          }
          input {
            width: 429px;
            height: 33px;
            border: none;
            border-radius: 10px;
            padding-left: 8px;
          }
        }
        p {
          text-align: right;
          color: #bfbebe;
          font-size: 10px;
        }
      }
      .reminder {
        color: #fff;
        p {
          margin-left: 10px;
        }
        div {
          width: 205px;
          min-height: 175px;
          border: 1px dashed #fff;
          border-radius: 10px;
          padding: 5px 8px 5px 0;
          margin-top: 8px;
          p {
            font-size: 12px;
            line-height: 17px;
            font-weight: normal;
            span {
              color: $bg-color;
              font-weight: normal;
            }
          }
        }
      }
    }
    .bind {
      height: 69px;
      background: $bg-color;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        width: 109px;
        height: 42px;
        background: #fff;
        border-radius: 10px;
        border: none;
        color: $bg-color;
        font-size: 22px;
        text-align: center;
        line-height: 42px;
      }
    }
    > p {
      height: 30px;
      color: #9d9b9b;
      font-size: 13px;
      display: flex;
      align-items: center;
      i {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px;
        border-color: transparent transparent transparent #9d9b9b;
        margin-left: 8px;
      }
    }
  }

  #good {
    min-width: 200px;
    height: 50px;
    background: #666;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -100px;
    margin-top: -25px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    opacity: 1;
    transition: all 0.3s;
    img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }

  #good.no {
    opacity: 0;
  }

  input[disabled] {
    background: #fff;
  }

  .continue-back {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.1);
    .continue-dialog {
      position: absolute;
      width: 300px;
      height: 130px;
      background: #fff;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      padding: 10px;
      font-size: 16px;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
      .continue-dialog-title {
        width: 100%;
        text-align: center;
        line-height: 35px;
      }
      .continue-dialog-button {
        margin-top: 30px;
        padding: 0 40px;
        color: #fff;
        text-align: center;

        .continue-yes {
          float: left;
          width: 60px;
          background: $bg-color;
          padding: 5px;
          border-radius: 3px;
          font-size: 14px;
        }
        .continue-no {
          float: right;
          width: 60px;
          background: $bg-color;
          padding: 5px;
          border-radius: 3px;
          font-size: 14px;
        }
      }

    }
  }


</style>



// WEBPACK FOOTER //
// src/view/IdCardUploadCheck.vue